/**
 * @generated SignedSource<<1c1f01fc8607a75bebdb1bcac82db8bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactMarketingView_contact$data = {
  readonly __typename: string;
  readonly contactIdentifier: string;
  readonly familyName?: string;
  readonly givenName?: string;
  readonly id: string;
  readonly teamName?: string;
  readonly " $fragmentType": "ContactMarketingView_contact";
};
export type ContactMarketingView_contact$key = {
  readonly " $data"?: ContactMarketingView_contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactMarketingView_contact">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactMarketingView_contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactIdentifier",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "givenName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "familyName",
          "storageKey": null
        }
      ],
      "type": "PersonContact",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamName",
          "storageKey": null
        }
      ],
      "type": "TeamContact",
      "abstractKey": null
    }
  ],
  "type": "Contact",
  "abstractKey": "__isContact"
};

(node as any).hash = "2ca2cfd947794b1165c139ddbfb8f6e0";

export default node;
